var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInsights = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 23",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.29 14.289a.996.996 0 0 1 1.41 0l1 1a.996.996 0 1 1-1.41 1.41l-1-1a.996.996 0 0 1 0-1.41Zm-16.59 0c.39.39.39 1.02 0 1.41l-1 1a.996.996 0 1 1-1.41-1.41l1-1a.996.996 0 0 1 1.41 0Zm19.01-13c.39.39.39 1.02 0 1.41l-1 1a.996.996 0 1 1-1.41-1.41l1-1a.996.996 0 0 1 1.41 0ZM4 8.999c0-4.42 3.58-8 8-8s8 3.58 8 8c0 1.98-.72 3.8-1.92 5.2-.88 1.03-1.63 2.03-1.93 3.08-.1.33-.15.66-.15.99v.73c0 2.21-1.79 4-4 4s-4-1.79-4-4v-.73c0-.33-.05-.66-.15-.99-.31-1.05-1.05-2.05-1.93-3.08A7.947 7.947 0 0 1 4 8.999Zm10.01 9H10v1c0 1.1.9 2 2 2s2-.9 2-2v-1h.01Zm-2.01-15c-3.31 0-6 2.69-6 6 0 1.49.54 2.85 1.44 3.9.74.87 1.57 1.91 2.07 3.1h4.97c.51-1.19 1.33-2.23 2.07-3.1.9-1.05 1.44-2.41 1.44-3.9 0-3.31-2.69-6-6-6H12ZM1.29 1.289c.39-.39 1.03-.39 1.42 0l1 1a.996.996 0 1 1-1.41 1.41l-1.01-.99c-.39-.39-.39-1.03 0-1.42Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInsights);
export default ForwardRef;